export default __webpack_public_path__ + "static/media/newGreenArrow.74f1b02a.svg";